import axios from 'axios';
import { authHeader } from '../_helpers';

const API_HOST=process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN : '';
const API_URL='/api';
const BASE_URL=API_HOST+API_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: authHeader(),
    'Content-Type': 'multipart/form-data' // 기본 Content-Type 설정
  }
});

export default {
  /** @params uri: string(baseUrl있음 /로 시작), data: FormData, config: object ex. config."Content-Type: multipart/form-data" */
  post(uri, data, config = {}) {
    return axiosInstance.post(uri, data, {
      ...config,
      headers: {
        ...axiosInstance.defaults.headers,
        ...config.headers // 추가된 headers를 덮어쓰기
      }
    });
  },
  /** @params uri: string, data: FormData, config: object ex. config."Content-Type: multipart/form-data" */
  get(uri, config = {}) {
    return axiosInstance.get(uri, {
      ...config,
      headers: {
        ...axiosInstance.defaults.headers,
        ...config.headers
      }
    });
  },
  /** @params uri: string, data: FormData, config: object ex. config."Content-Type: multipart/form-data" */
  put(uri, data, config = {}) {
    return axiosInstance.put(uri, data, {
      ...config,
      headers: {
        ...axiosInstance.defaults.headers,
        ...config.headers
      }
    });
  },/** @params uri: string, data: FormData, config: object ex. config."Content-Type: multipart/form-data" */
  patch(uri, data, config = {}) {
    return axiosInstance.patch(uri, data, {
      ...config,
      headers: {
        ...axiosInstance.defaults.headers,
        ...config.headers
      }
    });
  },
  /** @params uri: string, data: FormData, config: object ex. config."Content-Type: multipart/form-data" */
  delete(uri, config = {}) {
    return axiosInstance.delete(uri, {
      ...config,
      headers: {
        ...axiosInstance.defaults.headers,
        ...config.headers
      }
    });
  }
};
